<template>
    <div class="px-2 py-3 flex items-center justify-between">
        <div class="flex items-center gap-x-2">
            <div class="min-w-5">
                <component
                    class="text-gray-200"
                    :is="itemIcon"
                />
            </div>

            <div class="text-xs font-medium text-gray-370 dark:text-white">
                {{ item.title }}
            </div>
        </div>

        <div
            class="gap-x-2 flex items-center"
            :class="{ 'cursor-pointer' : isReject }"
            @click="goToRejectStep(item)"
        >
            <UpdateIcon
                v-if="isReject"
                class="text-red-700 dark:text-red"
            />

            <div
                class="h-6 w-22 flex items-center justify-center text-xs text-gray-370 dark:text-white border rounded-1.25"
                :class="itemStyles"
            >
                {{ currentStatus.label }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

import DocumentIcon20x20 from '@/components/icons/document/DocumentIcon20x20.vue'
import CardIcon20x20 from '@/components/icons/card/CardIcon20x20.vue'
import UpdateIcon from '@/components/icons/filterTable/UpdateIcon.vue'

import { useVerificationUserStore } from '@/store/call-tracking/verificationUserStore'

import { VERIFICATION_MINI_STEPS, STATUSES } from '@/constants/verification'

const props = defineProps({
    item: {
        type: Object,
        default: () => ({}),
    },
})

const verificationUserStore = useVerificationUserStore()

const itemIcon = computed(() => {
    switch (props.item.id) {
    case VERIFICATION_MINI_STEPS.kyc.id:
        return DocumentIcon20x20
    case VERIFICATION_MINI_STEPS.payment_method.id:
        return CardIcon20x20
    }
})

const itemStatus = computed(() => {
    switch (props.item.id) {
    case VERIFICATION_MINI_STEPS.kyc.id:
        return verificationUserStore.kycStepStatus
    case VERIFICATION_MINI_STEPS.payment_method.id:
        return verificationUserStore.paymentStepStatus
    }
})

const isReject = computed(() => itemStatus.value === STATUSES.rejected.id)

const currentStatus = computed(() => {
    switch (itemStatus.value) {
    case STATUSES.rejected.id:
        return STATUSES.rejected
    case STATUSES.confirmed.id:
        return STATUSES.confirmed
    default:
        return STATUSES.inReview
    }
})

const itemStyles = computed(() => {
    switch (itemStatus.value) {
    case STATUSES.rejected.id:
        return 'border-red-700 bg-red-800/20 dark:border-red dark:bg-red-800/25'
    case STATUSES.confirmed.id:
        return 'border-green-600 bg-green-600/10 dark:border-green-200 dark:bg-green-600/30'
    default:
        return 'border-yellow-350 bg-yellow-450/20 dark:border-yellow dark:bg-yellow-450/20'
    }
})

function goToRejectStep() {
    if (!isReject.value) {
        return
    }

    verificationUserStore.setReviewStep(props.item.id)
}
</script>
